export default __webpack_public_path__ + "static/test-image-2-c742cd5bebc22dfd4770912619f56537.jpg";